import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !["width", "height"].includes(prop),
})(({ width, height, theme }) => ({
  width,
  height,
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.white,
  border: `1.5px solid ${theme.palette.primary.main}`,
  borderRadius: theme.shape.customBorderRadius[0], // 5px

  "&:hover": {
    backgroundColor: theme.palette.primary.white,
    borderColor: theme.palette.primary.mainHover,
    color: theme.palette.primary.mainHover,
  },
  "&:active": {
    backgroundColor: theme.palette.primary.subBlue,
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  "&:disabled": {
    backgroundColor: theme.palette.primary.white,
    border: `1.5px solid ${theme.palette.primary.greyThird}`,
    color: theme.palette.primary.greyThird,
    cursor: "not-allowed",
  },
}));

export const OutlineRectangleButton = ({
  iconStart,
  iconEnd,
  width,
  height,
  children,
  ...rest
}) => {
  return (
    <StyledButton
      startIcon={iconStart}
      endIcon={iconEnd}
      width={width}
      height={height}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};
